import {createContext, ReactNode, useContext, useState} from "react";

import AlertModal from "components/AlertModal";

const AlertContext = createContext<{
  setContent: React.Dispatch<
    React.SetStateAction<
      | {
          title: string;
          message: string;
          callbackFn?: () => void;
          confirmLabel?: string;
        }
      | undefined
    >
  >;
}>({
  setContent: () => {
    return;
  },
});

export const AlertProvider = ({children}: {children: ReactNode}) => {
  const [content, setContent] = useState<{
    title: string;
    message: string;
    callbackFn?: () => void;
    confirmLabel?: string;
  }>();

  return (
    <AlertContext.Provider value={{setContent}}>
      {children}
      <AlertModal
        visible={content !== undefined}
        onClickConfirm={() => {
          setContent(undefined);
          if (content && content.callbackFn) content.callbackFn();
        }}
        title={content ? content.title : ""}
        message={content ? content.message : ""}
        confirmLabel={content ? content.confirmLabel : ""}
      />
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);

  return context.setContent;
};
